<!-- @migration-task Error while migrating Svelte code: $$props is used together with named props in a way that cannot be automatically migrated. -->
<script lang="ts">
    import { onMount } from "svelte";
    import { ApiKey, Game } from "../../model/Game";
    import { getAuthInfo, type AuthInfo } from "../../utility/AccountUtility";
    import BootstrapVectorIcon from "../components/BootstrapVectorIcon.svelte";
    import type { IGamesController } from "../../controller";
    import { ConfigurationManager } from "../../ConfigurationManager";
    import { DefaultErrorHandler, getMessagingService, MESSAGE_TYPE, type MessagingService } from "../../utility/ContextHelper.svelte";
    import { joinAndCapitalize } from "../../utility/helper";
    
    export let game: Game;

    /**
     * Set to true to display this as a horizontal card
     */
    export let horizontal: boolean = false;

    // If show keys is set to true and user is the owner of this game, we will show a list of api keys for this game
    export let showKeys: boolean = false;

    let shouldShowKeys: boolean = false;

    let keys: ApiKey[];

    let metDataController: IGamesController = ConfigurationManager.getInstance().gamesController;
    let msgService: MessagingService = getMessagingService();
    onMount(() => {
        let authInfo: AuthInfo = getAuthInfo();

        shouldShowKeys = showKeys && metDataController.isOwner(game, authInfo);

        if(shouldShowKeys) {
            
            metDataController.getApiKeys(game.id).then((newApiKeys: ApiKey[]) => {
                keys = newApiKeys;
            }).catch(DefaultErrorHandler);
        }
    })
    
    function secretify(s: string): string {
        let l: number = s.length;

        let result: string = "";
        for(let i = 0; i < 32; i++) {
            result += "*";
        }

        return result;
    }




    function createKey() {
        if(!metDataController.isOwner(game, getAuthInfo())) {
            msgService.BroadCastError("You are not the owner of this game");
            return;
        }
        metDataController.generateKey(game.id).then((key: ApiKey) => {
            msgService.BoradcastMessage("Key generated successfully", MESSAGE_TYPE.SUCCESS);
            keys.push(key);
            keys = keys;
        }).catch(DefaultErrorHandler);
    }

    function deactivateKey(keyId: string) {
        if(!metDataController.isOwner(game, getAuthInfo())) {
            msgService.BroadCastError("You are not the owner of this game");
            return;
        }
        metDataController.invalidateKey(game.id, keyId).then(() => {
            msgService.BoradcastMessage("Key deactivated successfully", MESSAGE_TYPE.SUCCESS);
            keys = keys.filter((a: ApiKey): boolean => {
                return a.id != keyId;
            });
        }).catch(DefaultErrorHandler);

    }
</script>

<div class="{$$props.class}" style="{$$props.style || ""}">
    <div class="card row mx-0 w-100 {horizontal ? "card-horizontal w-100" : ""}">
        
        {#if true}
            <div class="{horizontal ? "col-6" : "col-12"} cover-img-wrapper {horizontal ? "card-img-left" : "card-img-top p-0"}">
                <img src="assets/demo/{game.id}.jpg" class="w-100" alt="The banner for {game.name}" style="aspect-ratio: 16 / 9; object-fit: cover;">
            </div>
        {:else}
            <img src="" style="aspect-ratio: 16 / 9; object-fit: cover;" class="{horizontal ? "card-img-left" : "card-img-top"}" alt="No screenshot available">
        {/if}

        <div class="{horizontal ? "col-6" : "col-12"} card-body">
    
            <h3 class="card-title">
                <a href="#/game/{game.id}">{game.name}</a>
            </h3>
    

            <div class="row w-100">
                <div class="{horizontal ? "col-6" : "col-12"}">
                    <h3 class="h6 small text-info text-uppercase mb-3">About</h3>

                    <ul class="list-unstyled mb-2">
                        <li class="py-2">
                            <BootstrapVectorIcon
                                icon="building"
                                class="inline-bootstrap-icon me-2"
                            ></BootstrapVectorIcon>
                            {game.publisher}
                        </li>
                        <li class="py-2">
                            <BootstrapVectorIcon
                                icon="code"
                                class="inline-bootstrap-icon me-2"
                            ></BootstrapVectorIcon>
                            {joinAndCapitalize(game.genre)}
                        </li>
                        <li class="py-2">
                            <BootstrapVectorIcon
                                icon="pin-map"
                                class="inline-bootstrap-icon me-2"
                            ></BootstrapVectorIcon>
                            {joinAndCapitalize(game.setting)}
                        </li>
                        <li class="py-2">
                            <BootstrapVectorIcon
                                icon="eye"
                                class="inline-bootstrap-icon me-2"
                            ></BootstrapVectorIcon>
                            {joinAndCapitalize(game.style)}
                        </li>
                        <li class="py-2">
                            <BootstrapVectorIcon
                                icon="layers"
                                class="inline-bootstrap-icon me-2"
                            ></BootstrapVectorIcon>
                            {joinAndCapitalize(game.perspective)}
                        </li>

                    </ul>
                </div>

                <div class="{horizontal ? "col-6" : "col-12"}">

                    <div class="row">
                        <h3 class="col h6 small text-info text-uppercase mt-3 mb-3">Stats</h3>
                        <div class="col-auto mt-1">
                            <!-- @TODO add link to knowledge base for game stats-->
                            <BootstrapVectorIcon style="height: 2em; width:2em;" class="my-auto text-info" icon="question-circle"></BootstrapVectorIcon>
                        </div>
                        
                    </div>
                    
                    <ul class="list-unstyled mb-2">
                        <!-- <li class="py-2" title="Users online at any time" style="cursor: help;">
                            <BootstrapVectorIcon
                                icon="arrow-repeat"
                                class="inline-bootstrap-icon"
                            ></BootstrapVectorIcon>
                            {game.stats.averageUsersAtAnyTime.toLocaleString()}
                        </li> -->
                        <li class="py-2" title="Unique daily players" style="cursor: help;">
                            <BootstrapVectorIcon
                                icon="people"
                                class="inline-bootstrap-icon"
                            ></BootstrapVectorIcon>
                            {game.stats ? game.stats.dailyUniquePlayers.toLocaleString() : ""}
                        </li>
                        <li class="py-2" title="Total players" style="cursor: help;">
                            <span
                                class="inline-bootstrap-icon"
                            >∑</span>
                            {game.stats ? game.stats.totalPlayers.toLocaleString() : ""}
                        </li>
                    </ul>
                </div>
            </div>
            {#if shouldShowKeys}
                <div class="row overflow-scroll" style="max-height: 9em;">
                    <h4>ApiKeys</h4>
                    {#if keys}
                        {#each keys as key}
                            <div class="col-6 mx-0 pe-2 border-end border-light {key.active ? "": "text-muted"}">
                                <span class="float-start">
                                    <BootstrapVectorIcon icon="code-square" style="height: 1em; width: 1em;"></BootstrapVectorIcon> {key.id}
                                </span>
                                <button class="float-end btn btn-link py-0" style="cursor: pointer;" onclick={() => {
                                         navigator.clipboard.writeText(key.id);
                                         msgService.BoradcastMessage("Api key id copied", MESSAGE_TYPE.INFO);
                                    }}>
                                    <BootstrapVectorIcon icon="clipboard" style="height: 1em; width: 1em;"></BootstrapVectorIcon>
                                </button>
                            </div>
                            <div class="col-5 mx-0 ps-2 {key.active ? "": "text-muted"}">
                                <span class="float-start">
                                    <BootstrapVectorIcon icon="key" style="height: 1em; width: 1em;"></BootstrapVectorIcon> {secretify(key.key)}
                                </span>
                                <button class="float-end btn btn-link py-0" style="cursor: pointer;" onclick={() => {
                                         navigator.clipboard.writeText(key.key);
                                         msgService.BoradcastMessage("Api key secret copied", MESSAGE_TYPE.INFO);
                                    }}>
                                    <BootstrapVectorIcon icon="clipboard" style="height: 1em; width: 1em;"></BootstrapVectorIcon>
                                </button>
                            </div>
                            <div class="col-1">
                                <button class="float-end btn btn-link py-0" style="cursor: pointer;" onclick={() => {
                                        deactivateKey(key.id);
                                    }}>
                                    <BootstrapVectorIcon class="text-danger" icon="x-square-fill" style="height: 1em; width: 1em;"></BootstrapVectorIcon>
                                </button>
                            </div>
                        {/each}
                        <button class="btn btn-success py-1" onclick={createKey}><BootstrapVectorIcon icon="plus" style="height: 1em; width: 1em;"></BootstrapVectorIcon></button>
                    {/if}
                </div>
            {/if}

        </div>
    
    </div>
</div>

